import type { ReactNode } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import styles from '@/styles/components/tpsm/TpsmNavTabs.module.scss'

export type TpsmNavTabItem = {
  key: string
  to: string
  label: string
  /** Icon node (e.g. `<Package className={styles.tabIcon} aria-hidden />`). */
  icon: ReactNode
  /** Passed to React Router `NavLink` `end` (default: false; inventory uses `end`). */
  end?: boolean
}

export interface TpsmNavTabsProps {
  items: TpsmNavTabItem[]
}

function tabIsActive(pathname: string, item: TpsmNavTabItem): boolean {
  if (item.to === '/tpsm/inventory') {
    return pathname === '/tpsm/inventory' || pathname === '/tpsm' || pathname === '/tpsm/'
  }
  return pathname === item.to || (pathname.startsWith(`${item.to}/`) && !pathname.startsWith('/tpsm/supplier/'))
}

/**
 * Horizontal TPSM section tabs with icons passed per item.
 */
export function TpsmNavTabs({ items }: TpsmNavTabsProps) {
  const { pathname } = useLocation()

  return (
    <nav className={styles.root} aria-label="TPSM sections">
      <div className={styles.track}>
        {items.map((item) => (
          <NavLink
            key={item.key}
            to={item.to}
            end={item.end ?? item.to === '/tpsm/inventory'}
            className={() =>
              `${styles.tab} ${tabIsActive(pathname, item) ? styles.tabActive : ''}`.trim()
            }
          >
            <span className={styles.tabIcon}>{item.icon}</span>
            <span className={styles.tabLabel}>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
